import React from 'react';

import { fg } from '@confluence/feature-gating';
import type { ContentTypeBridgeAPI } from '@confluence/content-types-bridge/entry-points/content-types-shell-types.ts';
import {
	type UseCanvasFlagToShareParams,
	useCanvasFlagToShare,
} from '@confluence/experiment-twcg-2055-flag-to-share/entry-points/useCanvasFlagToShare.ts';

import { useRegisterShareCriteriaProgress } from './useRegisterShareCriteriaProgress.ts';

type CanvasFlagToShareRegistrarProps = UseCanvasFlagToShareParams & {
	bridge: ContentTypeBridgeAPI;
};

const EnabledCanvasFlagToShareRegistrar = ({
	bridge,
	contentId,
	type,
}: CanvasFlagToShareRegistrarProps): null => {
	const { shouldCollectProgress, notifyProgress } = useCanvasFlagToShare({ contentId, type });

	useRegisterShareCriteriaProgress({
		bridge,
		shouldCollectProgress,
		notifyProgress,
	});

	return null;
};

/** Keeps the canvas Flag-to-Share lifecycle unmounted until its production gate is enabled. */
export const CanvasFlagToShareRegistrar = (
	props: CanvasFlagToShareRegistrarProps,
): React.JSX.Element | null => {
	// oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
	if (props.type === 'slides' || !fg('twcg-2055-confluence-onboarding-flag-to-share-fg')) {
		return null;
	}

	return <EnabledCanvasFlagToShareRegistrar {...props} />;
};
